import React from 'react'
import Nav from './Nav'
import Title from './Title'
import Logo from './Logo'
import {version} from '../../package.json'

export default class Header extends React.Component {
  render() {
    return(
      <header className="App-header">
        <div className='container ms-menu mb10'>
          <div className= 'col-md-6'>
            <Nav auth={this.props.auth}/>
          </div>
          <div className= 'col-md-6'>
            <div className='pull-right'><Logo/> | <Title title={this.props.title}/> v{version} ({process.env.REACT_APP_ENV})</div>
          </div>
        </div>
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js